export enum LtiOperation {
  ListConsumingPlatforms = 'll-lti-registration:listConsumingPlatforms',
  FindConsumingPlatform = 'll-lti-registration:findConsumingPlatform',
  ListConsumedTools = 'll-lti-registration:listConsumedTools',
  ListConsumedToolDeployments = 'll-lti-registration:listConsumedToolDeployments',
  ListResourceLinks = 'll-lti-registration:listResourceLinks',
  ListResourceLinksByCohort = 'll-lti-registration:listResourceLinksByCohort',
}
